// import alegreyaSansImg from '@/shared/assets/webfonts/alegreya-sans.png';
// import domineImg from '@/shared/assets/webfonts/domine.png';
// import firaSansImg from '@/shared/assets/webfonts/fira-sans.png';
// import openSansImg from '@/shared/assets/webfonts/open-sans.png';
// import playfairDisplayImg from '@/shared/assets/webfonts/playfair-display.png';

import americanTypewriterItcImg from '@/shared/assets/webfont-images/american-typewriter-itc.png';
import annaClaraImg from '@/shared/assets/webfont-images/anna-clara.png';
import bellGothicImg from '@/shared/assets/webfont-images/bell-gothic.png';
import bernhardModernImg from '@/shared/assets/webfont-images/bernhard-modern.png';
import bookmanOldStyleImg from '@/shared/assets/webfont-images/bookman-old-style.png';
import budmoImg from '@/shared/assets/webfont-images/budmo.png';
import caslonIcgOpenFaceImg from '@/shared/assets/webfont-images/caslon-icg-open-face.png';
import garamondClassicoImg from '@/shared/assets/webfont-images/garamond-classico.png';
import gillSansMtImg from '@/shared/assets/webfont-images/gill-sans-mt.png';
import liebeErikaImg from '@/shared/assets/webfont-images/liebe-erika.png';
import liebeGerdaImg from '@/shared/assets/webfont-images/liebe-gerda.png';
import lifehackImg from '@/shared/assets/webfont-images/lifehack.png';
import mardianProImg from '@/shared/assets/webfont-images/mardian-pro.png';
import naiveInlineImg from '@/shared/assets/webfont-images/naive-inline.png';
import quickpenImg from '@/shared/assets/webfont-images/quickpen.png';
import revistaImg from '@/shared/assets/webfont-images/revista.png';
import rollerscriptImg from '@/shared/assets/webfont-images/rollerscript.png';
import rosalindaImg from '@/shared/assets/webfont-images/rosalinda.png';
import styledUpUprightImg from '@/shared/assets/webfont-images/styled-up-upright.png';
import windsongImg from '@/shared/assets/webfont-images/windsong.png';
import amaticScImg from '@/shared/assets/webfont-images/amatic-sc.png';
import cardoImg from '@/shared/assets/webfont-images/cardo.png';
import dancingScriptImg from '@/shared/assets/webfont-images/dancing-script.png';
import frederickaTheGreatImg from '@/shared/assets/webfont-images/fredericka-the-great.png';
import kirangHaerangImg from '@/shared/assets/webfont-images/kirang-haerang.png';
import lobsterImg from '@/shared/assets/webfont-images/lobster.png';
import monsieurLaDoulaiseImg from '@/shared/assets/webfont-images/monsieur-la-doulaise.png';
import overTheRainbowImg from '@/shared/assets/webfont-images/over-the-rainbow.png';
import patuaOneImg from '@/shared/assets/webfont-images/patua-one.png';
import pinyonScriptImg from '@/shared/assets/webfont-images/pinyon-script.png';
import poiretOneImg from '@/shared/assets/webfont-images/poiret-one.png';
import prataImg from '@/shared/assets/webfont-images/prata.png';
import quicksandImg from '@/shared/assets/webfont-images/quicksand.png';
import shadowsIntoLightTwoImg from '@/shared/assets/webfont-images/shadows-into-light-two.png';
import unnaImg from '@/shared/assets/webfont-images/unna.png';
import swiss721Img from '@/shared/assets/webfont-images/swiss-721.png';
import calibriImg from '@/shared/assets/webfont-images/calibri.png';
import champagneAndLimousinesImg from '@/shared/assets/webfont-images/champagne-and-limousines.png';
import huxtableImg from '@/shared/assets/webfont-images/huxtable.png';
import magnoliaSkyImg from '@/shared/assets/webfont-images/magnolia-sky.png';
import kudryashevImg from '@/shared/assets/webfont-images/kudryashev.png';
import luxusBrutImg from '@/shared/assets/webfont-images/luxus-brut.png';
import pinstripeLimoImg from '@/shared/assets/webfont-images/pinstripe-limo.png';
import thirstyScriptImg from '@/shared/assets/webfont-images/thirsty-script.png';
import thirstyScriptShadowImg from '@/shared/assets/webfont-images/thirsty-script-shadow.png';

/**
 * The id is the same as the filename prefix and used to
 * load e.g. the preview images: e.g. 'domine' -> 'domine.png'.
 * The name is the one which should be used as the class name,
 * e.g. "Domine" -> "font-family: Domine, sans-serif" and must
 * match the one named in the stylesheet (webfonts.scss).
 */

const webfonts = [
  /*
   * Free Fonts Google
   */
  // { id: 'open-sans', name: 'Open Sans', imageUrl: openSansImg },
  // { id: 'alegreya-sans', name: 'Alegreya Sans', imageUrl: alegreyaSansImg },
  // { id: 'domine', name: 'Domine', imageUrl: domineImg },
  // { id: 'fira-sans', name: 'Fira Sans', imageUrl: firaSansImg },
  // { id: 'playfair-display', name: 'Playfair Display', imageUrl: playfairDisplayImg },

  /*
   * fonts.com
   */
  { id: 'american-typewriter-itc', name: 'American Typewriter ITC', imageUrl: americanTypewriterItcImg },
  { id: 'anna-clara', name: 'Anna Clara', imageUrl: annaClaraImg },
  { id: 'bell-gothic', name: 'Bell Gothic', imageUrl: bellGothicImg },
  { id: 'bernhard-modern', name: 'Bernhard Modern', imageUrl: bernhardModernImg },
  { id: 'bookman-old-style', name: 'Bookman Old Style', imageUrl: bookmanOldStyleImg },
  { id: 'budmo', name: 'Budmo', imageUrl: budmoImg },
  { id: 'caslon-icg-open-face', name: 'Caslon ICG Open Face', imageUrl: caslonIcgOpenFaceImg },
  { id: 'garamond-classico', name: 'Garamond Classico', imageUrl: garamondClassicoImg },
  { id: 'lifehack', name: 'Lifehack', imageUrl: lifehackImg },
  { id: 'mardian-pro', name: 'Mardian Pro', imageUrl: mardianProImg },
  { id: 'naive-inline', name: 'Naive Inline', imageUrl: naiveInlineImg },
  { id: 'quickpen', name: 'Quickpen', imageUrl: quickpenImg },
  { id: 'revista', name: 'Revista', imageUrl: revistaImg },
  { id: 'rollerscript', name: 'Rollerscript', imageUrl: rollerscriptImg },
  { id: 'rosalinda', name: 'Rosalinda', imageUrl: rosalindaImg },
  { id: 'styled-up-upright', name: 'Styled Up Upright', imageUrl: styledUpUprightImg },
  { id: 'windsong', name: 'Windsong', imageUrl: windsongImg },

  /*
   * Linotype
   */
  { id: 'liebe-erika', name: 'Liebe Erika', imageUrl: liebeErikaImg },
  { id: 'liebe-gerda', name: 'Liebe Gerda', imageUrl: liebeGerdaImg },
  { id: 'gill-sans-mt', name: 'Gill Sans MT', imageUrl: gillSansMtImg },

  /*
   * Google
   */
  { id: 'amatic-sc', name: 'Amatic SC', imageUrl: amaticScImg },
  { id: 'cardo', name: 'Cardo', imageUrl: cardoImg },
  { id: 'dancing-script', name: 'Dancing Script', imageUrl: dancingScriptImg },
  { id: 'fredericka-the-great', name: 'Fredericka the Great', imageUrl: frederickaTheGreatImg },
  { id: 'kirang-haerang', name: 'Kirang Haerang', imageUrl: kirangHaerangImg },
  { id: 'lobster', name: 'Lobster', imageUrl: lobsterImg },
  { id: 'monsieur-la-doulaise', name: 'Monsieur La Doulaise', imageUrl: monsieurLaDoulaiseImg },
  { id: 'over-the-rainbow', name: 'Over the Rainbow', imageUrl: overTheRainbowImg },
  { id: 'patua-one', name: 'Patua One', imageUrl: patuaOneImg },
  { id: 'pinyon-script', name: 'Pinyon Script', imageUrl: pinyonScriptImg },
  { id: 'poiret-one', name: 'Poiret One', imageUrl: poiretOneImg },
  { id: 'prata', name: 'Prata', imageUrl: prataImg },
  { id: 'quicksand', name: 'Quicksand', imageUrl: quicksandImg },
  { id: 'shadows-into-light-two', name: 'Shadows Into Light Two', imageUrl: shadowsIntoLightTwoImg },
  { id: 'unna', name: 'Unna', imageUrl: unnaImg },

  /*
   * Mixed
   */

  { id: 'swiss-721', name: 'Swiss 721', imageUrl: swiss721Img },
  { id: 'calibri', name: 'Calibri', imageUrl: calibriImg },
  { id: 'champagne-and-limousines', name: 'Champagne and Limousines', imageUrl: champagneAndLimousinesImg },
  { id: 'huxtable', name: 'Huxtable', imageUrl: huxtableImg },
  { id: 'magnolia-sky', name: 'Magnolia Sky', imageUrl: magnoliaSkyImg },
  { id: 'kudryashev', name: 'Kudryashev', imageUrl: kudryashevImg },
  { id: 'luxus-brut', name: 'Luxus Brut', imageUrl: luxusBrutImg },
  { id: 'pinstripe-limo', name: 'Pinstripe Limo', imageUrl: pinstripeLimoImg },
  { id: 'thirsty-script', name: 'Thirsty Script', imageUrl: thirstyScriptImg },
  { id: 'thirsty-script-shadow', name: 'Thirsty Script Shadow', imageUrl: thirstyScriptShadowImg },
];

export default webfonts;
